import { createSlice } from "@reduxjs/toolkit";
import { fetchProducts } from "../thunk/fetchProducts";


const productsSlice = createSlice({
  name: 'products',
  initialState: {
    isLoading: false,
    data: [],
    error: null
  },
  reducers: {},
  extraReducers(builder){
    builder.addCase(fetchProducts.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchProducts.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchProducts.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
    builder.addCase("/addProduct", (state, action) => {
      state.data.push(action.payload);
    });
    builder.addCase("/editProduct", (state, action) => {
      const idx = state.data.findIndex(p => p.id === action.payload.id);
      if (idx !== -1) state.data[idx] = action.payload;
    });
    builder.addCase("/deleteProduct", (state, action) => {
      state.data = state.data.filter(p => p.id !== action.payload);
    });
  }
});

export const productsReducer = productsSlice.reducer;
